import { lazy } from "react";
import {
  AdminIcon,
  BlockedIcon,
  CasaDaliaIcon,
  CoursesIcon,
  DashboardIcon,
  MembershipsIcon,
  PathIcon,
  PowerSkillsIcon,
  PromoIcon,
  ReportsIcons,
  SettingsIcon,
  UsersListDiagnosticIcon,
  QuizzesIcon,
  UsersIcon,
  ProductsIcon,
  AudiosIcon,
  MentorshipsIcon,
  PapIcon,
  ReconnectIcon,
  AdnIcon,
  TransferIcon,
  CardIcon,
} from "../utils/constants/IconsConsts";
import MembershipManagment from "../views/membershipManagement";

//ERROR
const NoPermission = lazy(() => import("../views/noPermission"));

//Components viws Admin
const MultipleSubscription = lazy(
  () => import("../views/multipleSubscription"),
);
const Admins = lazy(() => import("../views/admins"));
const DetailAdmin = lazy(() => import("../views/admins/DetailAdmin"));
const NewAdmin = lazy(() => import("../views/admins/NewAdmin"));
const Settings = lazy(() => import("../views/settings"));
const CoworkCheckIn = lazy(() => import("../views/cowork/CheckIn"));

//Components views Connect
const Users = lazy(() => import("../views/connect/users"));
const UserNoMembership = lazy(
  () => import("../views/connect/users/DetailUserNoMembership"),
);
const UserDetailsTabs = lazy(
  () => import("../views/connect/users/DetailUserTabs"),
);
const DetailDiagnosticByEmail = lazy(
  () =>
    import("../components/views/users/diagnosticPowerSkill/DetailDiagnosticByEmail"),
);
const NewUser = lazy(() => import("../views/connect/users/NewUser"));
const UsersSegmentView = lazy(
  () => import("../views/connect/users/UsersSegmentView"),
);
const AssignMembership = lazy(
  () => import("../components/views/memberships/AssignMembership"),
);

//HomeViews
const HomeConnect = lazy(() => import("../views/connect/Home"));
const HomeCourses = lazy(() => import("../views/home/HomeCourses"));
const HomePrograms = lazy(() => import("../views/home/HomePrograms"));

const MembershipsConnect = lazy(() => import("../views/connect/memberships"));
const DetailMembershipsConnect = lazy(
  () => import("../views/connect/memberships/DetailMembership"),
);
const MembershipProducts = lazy(() => import("../views/membershipProducts"));
const EditMembershipProduct = lazy(
  () => import("../views/membershipProducts/EditMembershipProduct"),
);
const MembershipPromotions = lazy(
  () => import("../views/membershipPromotions"),
);
const SponsoredMemberships = lazy(() => import("../views/sponsoredMemberships"));
const NewMembership = lazy(
  () => import("../views/connect/memberships/NewMembership"),
);
const Courses = lazy(() => import("../views/courses/index"));
const NewCourse = lazy(() => import("../views/courses/NewCourse"));
const DetailCourse = lazy(() => import("../views/courses/DetailCourse"));
const Audios = lazy(() => import("../views/audios"));
const NewAudio = lazy(() => import("../views/audios/NewAudio"));
const EditAudio = lazy(() => import("../views/audios/EditAudio"));
const Mentorships = lazy(() => import("../views/mentorships"));
const LearningPaths = lazy(() => import("../views/learningPaths"));
const DetailLearningPath = lazy(
  () => import("../views/learningPaths/DetailLearningPath"),
);
const NewLearningPath = lazy(
  () => import("../views/learningPaths/NewLearningPath"),
);
const Promos = lazy(() => import("../views/promos"));
const NewPromo = lazy(() => import("../views/promos/NewPromo"));
const Profile = lazy(() => import("../views/profile"));

//HomeViews
const CoursesHome = lazy(() => import("../views/home/HomeCoursesRouter"));

const CoworkCheckInRoute = {
  url: "/dashboard/cowork/check-in",
  component: CoworkCheckIn,
};

const CasaDaliaRoute = {
  ...CoworkCheckInRoute,
  name: "CasaDalia",
  icon: CasaDaliaIcon,
};

//Report
const Reports = lazy(() => import("../views/reports"));
const PowerSkill = lazy(() => import("../views/powerSkill"));
const HomePowerSkillRouter = lazy(
  () => import("../views/home/HomePowerSkillRouter"),
);
const UsersListDiagnostic = lazy(
  () => import("../views/powerSkill/UsersPowerSkill"),
);

//Quizzes
const Quizzes = lazy(() => import("../views/quizzes"));
const Products = lazy(() => import("../views/products"));
const NewProduct = lazy(() => import("../views/products/NewProduct"));
const EditProduct = lazy(() => import("../views/products/EditProduct"));
const DetailCohort = lazy(() => import("../views/products/DetailCohort"));

//Pautas (solo lectura)
const PautasHome = lazy(() => import("../views/pautas/PautasHome"));
const PautasProducts = lazy(() => import("../views/pautas/PautasProducts"));
const PautasProductDetail = lazy(() => import("../views/pautas/PautasProductDetail"));
const PautasCohortParticipants = lazy(() => import("../views/pautas/PautasCohortParticipants"));

//Programs
const ProgramPowerAndPresence = lazy(() =>
  import("../views/programs/ProgramPowerAndPresence")
);
const ProgramReconnect = lazy(() => import("../views/programs/ProgramReconnect"));
const ProgramADN = lazy(() => import("../views/programs/ProgramADN"));
const IntensiveMakeItHappen = lazy(() =>import("../views/programs/IntensiveMakeItHappen"));


const CoursesRouter = {
  title: "COURSES",
  screens: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: DashboardIcon,
      component: CoursesHome,
    },
    {
      url: "/dashboard/crear-usuario",
      component: NewUser,
    },
    {
      name: "Cursos",
      url: "/dashboard/cursos",
      icon: CoursesIcon,
      component: Courses,
    },
    {
      url: "/dashboard/nuevo-curso",
      component: NewCourse,
    },
    {
      url: "/dashboard/curso-detalle",
      component: DetailCourse,
    },
    {
      name: "Audios",
      url: "/dashboard/audios",
      icon: AudiosIcon,
      component: Audios,
    },
    {
      url: "/dashboard/nuevo-audio",
      component: NewAudio,
    },
    {
      url: "/dashboard/editar-audio",
      component: EditAudio,
    },
    CoworkCheckInRoute,
  ],
};

//Default
const Default = {
  title: "NO_PERMISSION",
  screens: [
    {
      name: "NoPermission",
      url: "/dashboard",
      icon: BlockedIcon,
      component: NoPermission,
    },
    CoworkCheckInRoute,
  ],
};

//Unicef
const ReportExternal = {
  title: "ALLIANCE_UNICEF",
  screens: [
    {
      name: "Reportes",
      url: "/dashboard",
      icon: ReportsIcons,
      component: Reports,
    },
    {
      url: "/dashboard/reportes",
      icon: ReportsIcons,
      component: Reports,
    },
    CoworkCheckInRoute,
  ],
};

//Router Connect
const Connect = {
  title: "CONNECT",
  screens: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: DashboardIcon,
      component: HomeConnect,
    },
    {
      name: "Usuarios",
      url: "/dashboard/usuarios",
      icon: UsersIcon,
      component: Users,
    },
    {
      url: "/dashboard/usuario",
      component: UserNoMembership,
    },
    {
      url: "/dashboard/usuario-con-membresia",
      component: UserDetailsTabs,
    },
    {
      url: "/dashboard/usuario-power-skill",
      component: DetailDiagnosticByEmail,
    },
    {
      url: "/dashboard/crear-usuario",
      component: NewUser,
    },
    {
      name: "Cursos",
      url: "/dashboard/cursos",
      icon: CoursesIcon,
      component: Courses,
    },
    {
      url: "/dashboard/nuevo-curso",
      component: NewCourse,
    },
    {
      url: "/dashboard/curso-detalle",
      component: DetailCourse,
    },
    {
      name: "Audios",
      url: "/dashboard/audios",
      icon: AudiosIcon,
      component: Audios,
    },
    {
      url: "/dashboard/nuevo-audio",
      component: NewAudio,
    },
    {
      url: "/dashboard/editar-audio",
      component: EditAudio,
    },
    {
      name: "Mentorships",
      url: "/dashboard/mentorias",
      icon: MentorshipsIcon,
      component: Mentorships,
    },
    {
      name: "Membresías",
      url: "/dashboard/membresias",
      icon: MembershipsIcon,
      component: MembershipManagment,
    },
    {
      url: "/dashboard/connect/membresias",
      component: MembershipsConnect,
    },
    {
      url: "/dashboard/membresia-detalle",
      component: DetailMembershipsConnect,
    },
    {
      url: "/dashboard/crear-membresia",
      component: NewMembership,
    },
    {
      url: "/dashboard/productos-membresia",
      component: MembershipProducts,
    },
    {
      url: "/dashboard/productos-membresia/editar",
      component: EditMembershipProduct,
    },
    {
      name: "Pagos de membresía en evento",
      url: "/dashboard/promociones-membresia",
      icon: PromoIcon,
      component: MembershipPromotions,
    },
    { name: "Membresías patrocinadas", url: "/dashboard/membresias-patrocinadas", icon: PromoIcon, component: SponsoredMemberships },
    {
      url: "/dashboard/perfil",
      component: Profile,
    },
    CasaDaliaRoute,
  ],
};

//Router Connect
const UsersManagment = {
  title: "USERS_MANAGER",
  screens: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: DashboardIcon,
      component: HomeCourses,
    },
    {
      name: "Usuarios",
      url: "/dashboard/usuarios",
      icon: UsersIcon,
      component: Users,
    },
    {
      url: "/dashboard/usuarios-b2c",
      component: UsersSegmentView,
    },
    {
      url: "/dashboard/usuarios-b2b",
      component: UsersSegmentView,
    },
    {
      url: "/dashboard/usuarios-cupon",
      component: UsersSegmentView,
    },
    {
      url: "/dashboard/usuarios-nuevos",
      component: UsersSegmentView,
    },
    {
      url: "/dashboard/usuario",
      component: UserNoMembership,
    },
    {
      url: "/dashboard/usuario-con-membresia",
      component: UserDetailsTabs,
    },
    {
      url: "/dashboard/usuario-power-skill",
      component: DetailDiagnosticByEmail,
    },
    {
      url: "/dashboard/crear-usuario",
      component: NewUser,
    },
    {
      name: "PowerSkill",
      icon: PowerSkillsIcon,
      url: "/dashboard/diagnostico-power-skill",
      component: PowerSkill,
    },
    {
      url: "/dashboard/perfil",
      component: Profile,
    },
    CasaDaliaRoute,
    {
      name: "Mentorships",
      url: "/dashboard/mentorias",
      icon: MentorshipsIcon,
      component: Mentorships,
    },
    {
      name: "Productos_de_membresia",
      url: "/dashboard/productos-membresia",
      component: MembershipProducts,
      icon: MembershipsIcon,
    },
    {
      url: "/dashboard/productos-membresia/editar",
      component: EditMembershipProduct,
    },
    {
      name: "Pagos de membresía en evento",
      url: "/dashboard/promociones-membresia",
      icon: CardIcon,
      component: MembershipPromotions,
    },
    { name: "Membresías patrocinadas", url: "/dashboard/membresias-patrocinadas", icon: PromoIcon, component: SponsoredMemberships },
    {
      url: "/dashboard/asignar-membresia",
      component: AssignMembership,
    }
  ],
};

//Super Admin (router reservado; rol SUPER_ADMIN usa UsersManagment en getRouter)
// eslint-disable-next-line no-unused-vars -- definición conservada; no referenciada en getRouter
const SuperAdmin = {
  title: "SUPER_ADMIN",
  screens: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: DashboardIcon,
      component: HomeCourses,
    },
    {
      name: "Admin",
      url: "/dashboard/admins",
      icon: AdminIcon,
      component: Admins,
    },
    {
      url: "/dashboard/administrador",
      component: DetailAdmin,
    },
    {
      url: "/dashboard/crear-admin",
      component: NewAdmin,
    },
    {
      name: "Usuarios",
      url: "/dashboard/usuarios",
      icon: UsersIcon,
      component: Users,
    },
    {
      url: "/dashboard/usuarios-b2c",
      component: UsersSegmentView,
    },
    {
      url: "/dashboard/usuarios-b2b",
      component: UsersSegmentView,
    },
    {
      url: "/dashboard/usuarios-cupon",
      component: UsersSegmentView,
    },
    {
      url: "/dashboard/usuarios-nuevos",
      component: UsersSegmentView,
    },
    {
      url: "/dashboard/usuario",
      component: UserNoMembership,
    },
    {
      url: "/dashboard/usuario-con-membresia",
      component: UserDetailsTabs,
    },
    {
      url: "/dashboard/usuario-power-skill",
      component: DetailDiagnosticByEmail,
    },
    {
      url: "/dashboard/crear-usuario",
      component: NewUser,
    },
    {
      name: "Cursos",
      url: "/dashboard/cursos",
      icon: CoursesIcon,
      component: Courses,
    },
    {
      url: "/dashboard/nuevo-curso",
      component: NewCourse,
    },
    {
      url: "/dashboard/curso-detalle",
      component: DetailCourse,
    },
    {
      name: "Audios",
      url: "/dashboard/audios",
      icon: AudiosIcon,
      component: Audios,
    },
    {
      url: "/dashboard/nuevo-audio",
      component: NewAudio,
    },
    {
      url: "/dashboard/editar-audio",
      component: EditAudio,
    },
    {
      name: "Mentorships",
      url: "/dashboard/mentorias",
      icon: MentorshipsIcon,
      component: Mentorships,
    },
    {
      name: "Membresías",
      url: "/dashboard/membresias",
      icon: MembershipsIcon,
      component: MembershipManagment,
    },
    {
      url: "/dashboard/connect/membresias",
      component: MembershipsConnect,
    },
    {
      url: "/dashboard/membresia-detalle",
      component: DetailMembershipsConnect,
    },
    {
      url: "/dashboard/crear-membresia",
      component: NewMembership,
    },
    {
      url: "/dashboard/productos-membresia",
      component: MembershipProducts,
    },
    {
      url: "/dashboard/productos-membresia/editar",
      component: EditMembershipProduct,
    },
    {
      name: "Pagos de membresía en evento",
      url: "/dashboard/promociones-membresia",
      icon: CardIcon,
      component: MembershipPromotions,
    },
    { name: "Membresías patrocinadas", url: "/dashboard/membresias-patrocinadas", icon: PromoIcon, component: SponsoredMemberships },
    {
      url: "/dashboard/asignar-membresia",
      component: AssignMembership,
    },
    {
      name: "PowerSkill",
      icon: PowerSkillsIcon,
      url: "/dashboard/diagnostico-power-skill",
      component: PowerSkill,
    },
    {
      name: "Products",
      icon: ProductsIcon,
      url: "/dashboard/products",
      component: Products,
    },
    {
      url: "/dashboard/crear-producto",
      component: NewProduct,
    },
    {
      url: "/dashboard/editar-producto",
      component: EditProduct,
    },
    {
      url: "/dashboard/editar-producto/cohort",
      component: DetailCohort,
    },
    {
      name: "Quizzes",
      icon: QuizzesIcon,
      url: "/dashboard/quizzes",
      component: Quizzes,
    },
    {
      name: "LearningPaths",
      url: "/dashboard/learning-paths",
      icon: PathIcon,
      component: LearningPaths,
    },
    {
      url: "/dashboard/detail-learning-path",
      component: DetailLearningPath,
    },
    {
      url: "/dashboard/new-learning-path",
      component: NewLearningPath,
    },
    {
      name: "Promos",
      url: "/dashboard/promos",
      icon: PromoIcon,
      component: Promos,
    },
    {
      url: "/dashboard/new-promo",
      component: NewPromo,
    },
    {
      url: "/dashboard/multiples-subscripciones",
      component: MultipleSubscription,
    },
    /*  {
            name: "Transacciones",
            url: "/dashboard/transacciones",
            icon: TransationsIcon,
            component: HomeConnect
        },
        {
            name: "Reportes",
            url: "/dashboard/reportes",
            icon: ReportsIcons,
            component: Reports
        }, */
    CasaDaliaRoute,
    {
      name: "Ajustes",
      url: "/dashboard/ajustes",
      icon: SettingsIcon,
      component: Settings,
    },
    {
      url: "/dashboard/perfil",
      component: Profile,
    },
  ],
};

const PowerSkillDiagnostics = {
  title: "POWER_SKILL_DIAGNOSTICS",
  screens: [
    {
      name: "PowerSkill",
      icon: PowerSkillsIcon,
      url: "/dashboard",
      component: HomePowerSkillRouter,
    },
    {
      name: "UsuariosPowerSkill",
      icon: UsersListDiagnosticIcon,
      url: "/usuarios-diagnostico",
      component: UsersListDiagnostic,
    },
    {
      url: "/dashboard/usuario-power-skill",
      component: DetailDiagnosticByEmail,
    },
    {
      url: "/dashboard/perfil",
      component: Profile,
    },
    CasaDaliaRoute,
  ],
};

const ProgramsManager = {
  title: "PROGRAMS_MANAGER",
  screens: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: DashboardIcon,
      component: HomePrograms,
    },
    {
      name: "ProgramPowerAndPresence",
      url: "/dashboard/programa-poder-y-presencia",
      icon: PapIcon,
      component: ProgramPowerAndPresence,
    },
    {
      name: "ProgramReconnect",
      url: "/dashboard/programa-reconecta-contigo",
      icon: ReconnectIcon,
      component: ProgramReconnect,
    },
    {
      name: "ProgramADN",
      url: "/dashboard/programa-adn",
      icon: AdnIcon,
      component: ProgramADN,
    },
    {
      name: "IntensiveMakeIthappen",
      url: "/dashboard/programa-haz-que-las-cosas-sucedan",
      icon: TransferIcon,
      component: IntensiveMakeItHappen,
    },
    {
      url: "/dashboard/editar-producto/cohort",
      component: DetailCohort,
    },
  ],
};

//Pautas: acceso de solo lectura a Programas y Usuarios
const PautasManager = {
  title: "PAUTAS_MANAGER",
  screens: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: DashboardIcon,
      component: PautasHome,
    },
    {
      name: "Products",
      icon: ProductsIcon,
      url: "/dashboard/products",
      component: PautasProducts,
    },
    {
      name: "Usuarios",
      url: "/dashboard/usuarios",
      icon: UsersIcon,
      component: Users,
    },
    {
      url: "/dashboard/usuarios-b2c",
      component: UsersSegmentView,
    },
    {
      url: "/dashboard/usuarios-b2b",
      component: UsersSegmentView,
    },
    {
      url: "/dashboard/usuarios-cupon",
      component: UsersSegmentView,
    },
    {
      url: "/dashboard/usuarios-nuevos",
      component: UsersSegmentView,
    },
    {
      url: "/dashboard/usuario",
      component: UserNoMembership,
    },
    {
      url: "/dashboard/usuario-con-membresia",
      component: UserDetailsTabs,
    },
    {
      url: "/dashboard/usuario-power-skill",
      component: DetailDiagnosticByEmail,
    },
    {
      url: "/dashboard/producto-detalle",
      component: PautasProductDetail,
    },
    {
      url: "/dashboard/cohorte-participantes",
      component: PautasCohortParticipants,
    },
    {
      url: "/dashboard/perfil",
      component: Profile,
    },
  ],
};

export const getRouter = () => {
  const role = localStorage.getItem("AR");
  switch (role) {
    case "CONNECT_MANAGER":
      return Connect;
    case "CONNECT_ANALYST":
      return Connect;
    case "COURSES":
      return CoursesRouter;
    case "SUPER_ADMIN":
      return SuperAdmin;
    case "PROGRAM_MANAGER":
      return ProgramsManager;
    case "PAUTAS_MANAGER":
      return PautasManager;
    case "ALLIANCE_UNICEF":
      return ReportExternal;
    case "USERS_MANAGER":
      return UsersManagment;
    case "POWER_SKILL_DIAGNOSTICS":
      return PowerSkillDiagnostics;
    case "ERROR":
      return Default;
    default:
      return Default;
  }
};
